export { default } from '@/features/shiftCloseouts/pages/ShiftCloseoutsPage'
